import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useGetCallTypeQuery } from "./service"
import { CallTypeForm } from "./call-type-form"

export const CallTypeEditPage = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isCreate = id === "new"
  const callTypeId = isCreate ? undefined : +id!
  const { data: callType, isLoading } = useGetCallTypeQuery(callTypeId!, { skip: isCreate })
  const organizationGroupId = isCreate
    ? +(searchParams.get("organizationGroupId") || "0")
    : callType?.organization_group_id || 0

  if (isLoading) {
    return <div>Загрузка...</div>
  }

  if (!isCreate && !callType) {
    return <div>Тип звонка не найден</div>
  }

  return <CallTypeForm callType={callType} organizationGroupId={organizationGroupId} onClose={() => navigate(-1)} />
}
